// Wiki Referral Code functionality

document.addEventListener('DOMContentLoaded', function() {
  window.initializeReferralData();
});

// Make initializeReferralData globally available for dynamic content updates
window.initializeReferralData = function() {
  const currentReferralInput = document.getElementById('currentReferral');
  if (currentReferralInput) {
    const currentReferral = currentReferralInput.value;
    const truncatedCode = document.getElementById('truncatedCode')?.value;
    const currentRefUserName = document.getElementById('currentRefUserName')?.value;
    const currentRefUserPath = document.getElementById('currentRefUserPath')?.value;
    const referralType = document.getElementById('referralType')?.value;
    
    if (referralType === 'code') {
      // Populate referral code
      const codeElement = document.getElementById('referal-code');
      const hiddenCodeElement = document.getElementById('current_referral_code');
      if (codeElement && truncatedCode) {
        codeElement.textContent = truncatedCode;
      }
      if (hiddenCodeElement && currentReferral) {
        hiddenCodeElement.textContent = currentReferral;
      }
    } else if (referralType === 'link') {
      // Populate referral links
      const linkElements = document.querySelectorAll('.referral-link');
      linkElements.forEach(function(linkElement) {
        if (currentReferral) {
          linkElement.href = currentReferral;
        }
      });
    }
    
    // Populate user info
    const userElements = document.querySelectorAll('.referral_user');
    userElements.forEach(function(userElement) {
      if (currentRefUserName) {
        userElement.textContent = currentRefUserName;
      }
      if (currentRefUserPath) {
        userElement.href = currentRefUserPath;
      }
    });
  }
}

window.copyReferralCode = function(button) {
  const hiddenCodeElement = document.getElementById('current_referral_code');
  const code = hiddenCodeElement ? hiddenCodeElement.textContent : '';
  
  if (code) {
    navigator.clipboard.writeText(code).then(() => {
      // Show copied feedback
      const originalHTML = button.innerHTML;
      button.innerHTML = '<span class="text-white text-xs">Copied!</span>';
      setTimeout(() => {
        button.innerHTML = originalHTML;
      }, 1500);
    });
  }
}

window.toggleReferralForm = function() {
  const collapsed = document.getElementById('referral-collapsed');
  const expanded = document.getElementById('referral-expanded');
  const plusIcon = document.getElementById('plus-icon-wrapper');
  const closeIcon = document.getElementById('close-icon-wrapper');
  
  // Check current state - if plus icon doesn't have 'hidden' class, we're in collapsed state
  const isCollapsed = !plusIcon.classList.contains('hidden');
  
  if (isCollapsed) {
    // Switch to expanded state - show close icon and form
    plusIcon.classList.add('hidden');
    plusIcon.classList.remove('flex');
    closeIcon.classList.remove('hidden');
    closeIcon.classList.add('flex');
    collapsed.classList.add('hidden');
    collapsed.classList.remove('flex');
    expanded.classList.remove('hidden');
    expanded.classList.add('block');
  } else {
    // Switch to collapsed state - show plus icon and text
    plusIcon.classList.remove('hidden');
    plusIcon.classList.add('flex');
    closeIcon.classList.add('hidden');
    closeIcon.classList.remove('flex');
    collapsed.classList.remove('hidden');
    collapsed.classList.add('flex');
    expanded.classList.add('hidden');
    expanded.classList.remove('block');
  }
}

window.showReferralSuccess = function() {
  const collapsed = document.getElementById('referral-collapsed');
  const expanded = document.getElementById('referral-expanded');
  const success = document.getElementById('referral-success');
  const toggleBtn = document.getElementById('referral-toggle-btn');
  
  // Hide the collapsed/expanded states and toggle button
  if (collapsed) {
    collapsed.classList.add('hidden');
    collapsed.classList.remove('flex');
  }
  if (expanded) {
    expanded.classList.add('hidden');
    expanded.classList.remove('block');
  }
  if (toggleBtn) {
    toggleBtn.classList.add('hidden');
  }
  
  // Show success state
  if (success) {
    success.classList.remove('hidden');
    success.classList.add('block');
  }
}

